import { Box, Button, TextField } from "@mui/material"
import { AccountCircle, LockOpen } from '@mui/icons-material';
import "./Login.scss"
import { useNavigate } from "react-router-dom";
import LogoTraffic from '../../assets/TrafficLight_Logo.png'
import { useState } from "react";
import axios from "axios";
import { Url } from "../../constants";
import Swal from "sweetalert2";
import Loader from "../../Layout/Loader/Loaders";

const Login = () => {

    const Navigate = useNavigate();
    const [datos, setdatos] = useState({"email":"", "password":""})
    const [isCharging, setisCharging] = useState(false)

    const handleChange = (event) => {
        const value = event.target.value
        const name = event.target.name

        const copyobj = {...datos}
        copyobj[name] = value
        
        setdatos(copyobj)
    }
    const pressEnter = (event) => {
        if (event.keyCode === 13) {
            doLogin()
        }
    }

    const doLogin = async () => {
        setisCharging(true)

        await axios.post(Url + "LoginPortal", datos)
        .then(res => {
            let token = res.data.token_type + " " + res.data.token;
            localStorage.setItem("token", token)
            setisCharging(false)

            axios.get(Url + "Io", {
                headers:{
                    Authorization: token
                }
            })
            .then(res => {
                const userdatos = {
                    user_id: res.data.id,
                    user_name: res.data.email,
                    roluser_id: res.data.usuario_rol.id,
                    roluser_name: res.data.usuario_rol.rol
                }

                localStorage.setItem("user", JSON.stringify(userdatos))
            })
            .catch(err => {
                console.log(err)
            })

            Navigate('/main')
        })
        .catch(err => {
            setisCharging(false)

            Swal.fire(err.response.data.messages, "", 'error')
            console.log(err)
        })
    }

    //() => Navigate('/main')

    return (
        <div style={{position:"relative"}}>
        <Box className="background" />
        <Box className="over_background">
            <Box className="cardLogin">
                <img src={LogoTraffic} alt="LogoTL"
                width={"45%"} style={{marginTop:"3%", marginBottom:"2%"}}/>
                <div className="texto">
                    <div className="etiqueta">
                        <AccountCircle/>
                        <label>Usuario:</label>
                    </div>
                    <TextField sx={{backgroundColor:"white", borderRadius:"5px"}} size="small"
                    placeholder="example@trafficlight.mx" fullWidth onChange={handleChange} name="email" 
                    value={datos.email}
                    slotProps={{input:{style: {fontSize:"15px"}}}}/>
                </div>

                <div className="texto">
                    <div className="etiqueta">
                        <LockOpen/>
                        <label>Contraseña:</label>
                    </div>
                    <TextField sx={{backgroundColor:"white", borderRadius:"5px"}} size="small"
                    placeholder="Password" fullWidth type="password" onChange={handleChange} name="password"
                    value={datos.password} onKeyDown={pressEnter}
                    slotProps={{input:{style: {fontSize:"15px"}}}}/>
                </div>

                <Button variant="contained" onClick={doLogin}>
                    INGRESAR
                </Button>
            </Box>
        </Box>

        {isCharging && <Loader />}
        </div>

    );
}

export default Login;
